import React from 'react'
import _ from 'lodash'
import { useIntl } from 'react-intl'
import { Add } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import { QuestionState } from '../../../../../features/types'
import OptionsDnd from './Dnd/OptionsDnd'

const styles = {
    boxContainer: {
        maxWidth: 600,
        pt: 2,
    },

    addChoice: {
        display: 'flex',
        mt: 2,
    },
}

interface OptionsProps {
    formik: any
    questionIndex: number
    question: QuestionState
    resetCorrectAnswers: (question: QuestionState) => void
}

const Options: React.FC<OptionsProps> = ({
    formik,
    questionIndex,
    question,
    resetCorrectAnswers,
}) => {
    const { formatMessage } = useIntl()

    const handleAdd = () => {
        formik.setFieldValue(`questions[${questionIndex}].answers`, [
            ...question.answers,
            {
                answerId: Date.now(),
                content: '',
                position: 0,
                correct: false,
            },
        ])
    }

    const setAnswersOrder = (elements) => {
        formik.setFieldValue(`questions[${questionIndex}].answers`, elements)
    }

    const handleDelete = (id: string | number) => {
        const filteredItems = question.answers.filter(
            (item) => (item.id || item.answerId) !== id,
        )

        formik.setFieldValue(
            `questions[${questionIndex}].answers`,
            filteredItems,
        )
    }

    const handleBadgeClick = (index: number) => {
        if (question.questionTypeEnum === 'ONE_ANSWER') {
            resetCorrectAnswers(question)

            formik.handleChange({
                target: {
                    name: `questions[${questionIndex}].answers[${index}].correct`,
                    value: !question.answers[index]?.correct,
                },
            })
        } else if (question.questionTypeEnum === 'MULTI_SELECT') {
            formik.handleChange({
                target: {
                    name: `questions[${questionIndex}].answers[${index}].correct`,
                    value: !question.answers[index]?.correct,
                },
            })
        }
    }

    return (
        <Box sx={styles.boxContainer}>
            <OptionsDnd
                formik={formik}
                questionIndex={questionIndex}
                setItems={setAnswersOrder}
                handleDelete={handleDelete}
                handleBadgeClick={handleBadgeClick}
            />

            <Box sx={styles.addChoice}>
                <Button
                    endIcon={<Add />}
                    sx={{ marginLeft: 'auto' }}
                    onClick={handleAdd}
                >
                    {formatMessage({ id: 'addChoice' })}
                </Button>
            </Box>
        </Box>
    )
}

export default Options
